import { render, staticRenderFns } from "./SourcesTemplate.vue?vue&type=template&id=14e7a4aa"
import script from "./SourcesTemplate.vue?vue&type=script&lang=js"
export * from "./SourcesTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports